<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><span>G. K. Chesterton’s fictional detective,<br/>Father Brown, posed two riddles.</span></p>
<p class="center1"><span>Where would a wise man hide a leaf?<br/>In the forest.</span></p>
<p class="center1"><span>Where would a wise man hide a body?<br/>On a battlefield.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?16a8854a